import { ConditionConnector } from './calculation-classes';
import { ConditionItem } from './condition-item';
import { ConditionStorage } from './condition-storage';
import { ConditionTemplate } from './condition-template';
import { CoordinatorService } from './coordinator.service';

export class Condition$ {
    private _conditionItemMap = new Map<string, ConditionItem>();
    private _xitemId2conditionLsMap = new Map<string, ConditionItem[]>();

    private _conditionTemplateMap = new Map<string, ConditionTemplate>();
    private _conditionStorageMap = new Map<string, ConditionStorage>();

    private _currentTemplate?: ConditionTemplate | undefined;

    constructor(public coords: CoordinatorService) {}

    public get currentTemplate(): ConditionTemplate | undefined {
        try {
            if (!this._conditionTemplateMap.size) return undefined;
            if (!this._currentTemplate)
                this.currentTemplate = this._conditionTemplateMap.values().next().value;
            return this._currentTemplate;
        } catch (e) {
            return undefined;
        }
    }
    public set currentTemplate(value: ConditionTemplate | undefined) {
        this._currentTemplate = value;
        this.coords.display$.markForCheck();
    }

    get sortedList() {
        const ls = Array.from(this._conditionTemplateMap.values());
        ls.sort((a, b) => (a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1));
        return ls;
    }

    dialogSearch(cond: ConditionTemplate): void {
        this.coords.display$.dialog$.next({
            action: 'search-condition',
            cond,
        });
    }

    formulaEditor(target: any, backFun?: () => void) {
        this.coords.display$.dialog$.next({
            action: 'formula-editor',
            target,
            backFun,
        });
    }

    clear() {
        this._conditionItemMap.clear();
        this._conditionTemplateMap.clear();
        this._conditionStorageMap.clear();
        this._currentTemplate = undefined;
    }

    addTemplate(cTemplate: ConditionTemplate) {
        this._conditionTemplateMap.set(cTemplate.id, cTemplate);
        this.coords.display$.markForCheck();
    }

    xitemConditionConnector(xitmId: string) {
        const ls = this._xitemId2conditionLsMap.get(xitmId);
        return new ConditionConnector(this.coords, ls);
    }

    addItem(citm: ConditionItem) {
        this._conditionItemMap.set(citm.id, citm);
        const xitmMp = this._xitemId2conditionLsMap;
        let ls = xitmMp.get(citm.itemId);
        if (!ls) {
            ls = [];
            xitmMp.set(citm.itemId, ls);
        }
        ls.push(citm);
        this.coords.display$.markForCheck();
    }

    getConditionInstance(itemId: string, ownerId?: string) {
        if (!ownerId) ownerId = this.coords.user$.currentId || '_unlogged';
        for (let citm of this._conditionItemMap.values()) {
            if (citm.itemId === itemId && citm.ownerId === ownerId) return citm;
        }
        return undefined;
    }

    get conditionItemLs() {
        return Array.from(this._conditionItemMap.values());
    }

    get templateLs() {
        return Array.from(this._conditionTemplateMap.values());
    }

    load3(ls: any[]) {
        ls.forEach((x) => {
            if (!x) return;
            try {
                const t = new ConditionTemplate(this.coords, x.conditionTemplate);
                this.addTemplate(t);
            } catch (e) {
                this.coords.utils$.consoleError('LOAD3 CONDITION-TEMPLATE', e);
            }
        });
    }
    load3storage(ls: any[]) {
        ls.forEach((x) => {
            if (!x?.conditionStorage?.conditionItemLs?.length) return;
            try {
                // console.log('VITM STORAGE', x);
                x.conditionStorage.conditionItemLs.forEach((citmParams: any) => {
                    if (!this._conditionTemplateMap.has(citmParams.templateId)) return;
                    const citm = new ConditionItem(this.coords, citmParams);
                    this.addItem(citm);

                    if (!this.getStorage(citm.templateId)) {
                        const storage = new ConditionStorage(this.coords, {
                            id: x.conditionStorage.id,
                            templateId: citm.templateId,
                        });
                        this._conditionStorageMap.set(citm.templateId, storage);
                    }

                    this.storeConditionItem(citm, true);
                });
            } catch (e) {
                this.coords.utils$.consoleError('LOAD3 VI-STORAGE', e);
            }
        });
    }

    get(vitmId: string) {
        return this._conditionItemMap.get(vitmId);
    }

    getTemplate(templateId: string) {
        return this._conditionTemplateMap.get(templateId);
    }

    getStorage(templateId: string) {
        return this._conditionStorageMap.get(templateId);
    }

    storeConditionItem(citm: ConditionItem, isLoad = false) {
        let storage = this.getStorage(citm.templateId);
        if (!storage) {
            storage = new ConditionStorage(this.coords, {
                templateId: citm.templateId,
            });
            this._conditionStorageMap.set(citm.templateId, storage);
        }
        storage.update(citm, isLoad);
    }

    createTemplate() {
        const t = new ConditionTemplate(this.coords, {});
        return t;
    }

    deleteTemplate(t: ConditionTemplate) {
        this._conditionTemplateMap.delete(t.id);
        this.coords.display$.markForCheck();
    }

    editDialog(template?: ConditionTemplate) {
        this.coords.display$.dialog$.next({
            action: 'conditions-editor',
            template,
        });
    }
}
